export enum ECookies {
  preferredLocation = 'so_preferred_location_id',
  isCookieAccept = 'is_cookie_accept',
  ldUserKey = 'launch_darkly_user_key',
  isAcknowledgedDefaultLocation = 'is_acknowledged_default_location',
  cookieDisclaimerHasShown = 'cookie_disclaimer_has_shown',
  userId = 'user_id',
}
